// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yy5mb","content":"styles_content__1pODv","tableWrap":"styles_tableWrap__2laPA"};